var map = {
	"./background-splash.mp4": 38377,
	"./bg-texture-paint.jpg": 56532,
	"./bg-texture-plain.jpg": 44664,
	"./cart-icon.png": 50134,
	"./cosmo-logo.png": 88427,
	"./favicon.svg": 64693,
	"./fonts/neuehaas-roman.ttf": 48903,
	"./fonts/stalinist-one.ttf": 42223,
	"./icon-black-bg.png": 91897,
	"./icon-black-bg.svg": 79854,
	"./icon-black.svg": 45482,
	"./icon-white-bg.svg": 99080,
	"./icon-white.svg": 58832,
	"./no-image.png": 31537,
	"./profile-icon.png": 68051,
	"./search.png": 91060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;